import ExportsRepository from 'repositories/CurrentUser/ExportsRepository';

export function backgroundExport(params) {
  return () => ExportsRepository.create(params).then(({ exportJob }) => exportJob);
}
